<template>
    <div class="row transparencia">
        <ul class="nav nav-tabs col-12 noRequierePadding" role="tablist">
            <li v-for="seccionQueMePerteneceTrimestral in seccionDeLaPaginaWeb.SeccionesQueMePertenecen" v-bind:key="seccionQueMePerteneceTrimestral.SeccionDeLaPaginaWebId" v-bind:class="CreaLaClaseDeCol(seccionDeLaPaginaWeb.TamanoDeMiDescendiente, false)" class="nav-item bordesPrimarios noRequierePadding">
                <a v-on:click="LimpiarLasSeccionesYCargarLaNueva(seccionQueMePerteneceTrimestral)" class="col-12 nav-link noRequierePadding" data-toggle="tab" role="tab" aria-selected="true" >{{seccionQueMePerteneceTrimestral.NombreDeLaSeccion}}</a>
            </li>
        </ul>
        <ul v-if="EstaVacioLosDatos(seccionACargarDeObligaciones) == false" class="nav nav-tabs col-12 noRequierePadding" role="tablist">
            <li v-for="seccionQueMePerteneceObligaciones in seccionACargarDeObligaciones.SeccionesQueMePertenecen" v-bind:key="seccionQueMePerteneceObligaciones.SeccionDeLaPaginaWebId" v-bind:class="CreaLaClaseDeCol(seccionACargarDeObligaciones.TamanoDeMiDescendiente, false)" class="nav-item bordesSecundarios noRequierePadding">
                <a v-on:click="seccionDeLaObligacion = seccionQueMePerteneceObligaciones" class="col-12 nav-link noRequierePadding" data-toggle="tab" role="tab" aria-selected="true" >{{seccionQueMePerteneceObligaciones.NombreDeLaSeccion}}</a>
            </li>
        </ul>
        <div v-if="EstaVacioLosDatos(seccionDeLaObligacion) == false" class="col-12 contenidoDeLaInformacion noRequierePadding">
            <div v-for="contenido in seccionDeLaObligacion.ContenidosDeLaPaginaWeb" v-bind:key="contenido.ContenidosDeLaPaginaWebId" v-bind:class="CreaLaClaseDeCol(seccionDeLaObligacion.TamanoDeMiDescendiente, true)" class="acomodaLasObligaciones col-6 col-sm-4 col-md-3">
                <div class="tarjetaDeLaObligacion col-12 noRequierePadding">
                    <img :src="contenido.RutaDeImagen" />
                    <h6 class="text-center">{{contenido.TextoDelContenido}}</h6>
                    <a v-if="contenido.ArchivosDeContenidoDeLaPaginaWeb.length > 0 && contenido.MostrarArchivos == false" class="btn btn-success acomodaElBotonDeDescarga col-12 noRequierePadding" v-on:click="contenido.MostrarArchivos = !contenido.MostrarArchivos"><i class="fas fa-folder"></i>&nbsp;Mostrar los documentos</a>
                    <a v-else-if="contenido.ArchivosDeContenidoDeLaPaginaWeb.length > 0 && contenido.MostrarArchivos == true" class="btn btn-success acomodaElBotonDeDescarga col-12 noRequierePadding" v-on:click="contenido.MostrarArchivos = !contenido.MostrarArchivos"><i class="fas fa-folder-open"></i>&nbsp;Cerrar los documentos</a>
                    <div v-if="contenido.ArchivosDeContenidoDeLaPaginaWeb.length > 0 && contenido.MostrarArchivos == true" class="text-left">
                        <a v-for="archivoDeContenidoDeLaPaginaWeb in contenido.ArchivosDeContenidoDeLaPaginaWeb" v-bind:key="archivoDeContenidoDeLaPaginaWeb.ArchivoDeContenidoDeLaPaginaWebId" class="btn btn-default descargaDelArchivo col-12 noRequierePadding" v-on:click="AbrirDocumento(archivoDeContenidoDeLaPaginaWeb.RutaDeArchivoCarpeta, '_self')">
                            <i class="fas fa-file"></i>&nbsp;{{archivoDeContenidoDeLaPaginaWeb.TextoDelVinculo}}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import comun from "@/../static/js/comun";
export default {
    data() { 
      return {
        seccionACargarDeObligaciones: Object,
        seccionDeLaObligacion: Object
      }
    },
    props: {
        seccionDeLaPaginaWeb: Object
    }, 
    methods: {
        CreaLaClaseDeCol: function(tamanoDeLaColumna, colImpuesto) {
            if (colImpuesto)
                return "col-lg-2 col-xl-2";
            else
                return "col-md-" + tamanoDeLaColumna + " col-" + tamanoDeLaColumna;
        }, 
        EstaVacioLosDatos: function(objeto) {
            return objeto === undefined || objeto === null || Object.keys(objeto).length === 0 ? true : false;
        },
        LimpiarLasSeccionesYCargarLaNueva: function(seccion){
            this.seccionACargarDeObligaciones = seccion;
            this.seccionDeLaObligacion = Object;

        },
        AbrirDocumento: function(vinculo, formaDeApertura) {
          comun.DescargarDocumentoPDF(vinculo)
            //window.open(vinculo, formaDeApertura);
        }
    }
}
</script>

<style scoped>
  .transparencia {
    width: 100%;
  }

  h6 {
    display: block;
    padding-left: 15px;
    padding-right: 15px;
    min-height: 60px;
  }

  ul {
      text-align: center;
  }

  img {
      display: block
  }

    .noRequierePadding {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }

  .nav-tabs {
      border: none;
  }

  .nav-item {
      margin-bottom: 0;
      padding-bottom: 0 !important;
      color: white !important;
  }

  .nav-link {
    background-color: rgb(34,34,34) !important;
    color: white;
    font-weight: 500;
  }

  .nav-link:hover {
      border-bottom: 1px solid rgb(63, 63, 63) !important;
      background-color: rgb(63, 63, 63) !important;
      border-color: rgb(63, 63, 63) rgb(63, 63, 63) rgb(63, 63, 63) rgb(63, 63, 63) !important;
  }

  .active {
    border: none !important;
    border-bottom: 1px solid rgb(63, 63, 63) !important;
    background-color: rgb(63, 63, 63) !important;
    border-color: rgb(63, 63, 63) rgb(63, 63, 63) rgb(63, 63, 63) rgb(63, 63, 63) !important;
    color:white !important;
  }

  .bordesPrimarios {
    border-radius: 5px 5px 0 0;
    border: .5px solid #dee2e6 !important;
    background-color: rgb(34,34,34) !important;
  }

  .bordesSecundarios {
    border-radius: 0;
    border: .5px solid #dee2e6 !important;
    background-color: rgb(34,34,34) !important;
  }

  .contenidoDeLaInformacion {
    border: 1px solid rgb(160, 160, 160) !important;
    background-color: rgba(0,0,0,.05) !important;
  }

  .acomodaLasObligaciones {
    display: inline-flex;
    overflow-wrap: break-word;
    padding: 20px;
  }

  .tarjetaDeLaObligacion {
    display: block;
    border: 1px solid rgb(194, 194, 194);
    background-color: white;
  }

  .acomodaElBotonDeDescarga {
    white-space: pre-wrap;
  }

  .tarjetaDeDescarga {
    display: block;
    border: 1px solid rgb(194, 194, 194);
    background-color: white;
  }

  .descargaDelArchivo {
      background-color: white !important;
      white-space: inherit;
  }

  .descargaDelArchivo:hover {
      background-color: rgb(228, 228, 228) !important;
  }

  .btn {
      border-radius: 0px !important;
  }

  .btn-success {
      color: white !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaInformativa/Formatos/Transparencia.vue